import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getTranslate} from 'react-localize-redux';
import api from '../../../helpers/api';
import {loadLanguage} from '../../../common/redux/localeReducer';
import {notifySuccess, notifyError, notifyShow} from '../../../common/redux/notificationReducer';
import {ContentLoader} from '../../../common/components/loader';
import stationManagerAlertDashboard from '../locales/stationManagerAlertDashboard.json';
import {Label, Select} from "../../../common/components/form";
import {formatDate} from "../../../helpers/utils";
import moment from "moment";
import socket from "../../../helpers/socket";

class StationManagerAlertDashboard extends Component {
	constructor(props) {
		super(props);

		const {loadLanguage} = props;
		loadLanguage(stationManagerAlertDashboard);

		this.state = {
			isLoading: true,
			stations: [],
			stationsList: [],
			stationAlertsList: [],
			alerts: [],
			searchForm: {
				station_id: '',
				station_alert_id: ''
			},
			showAnimation: false
		};

		socket().on('alert.create', (data) => {
			this.newAlertCreated(data);
		});

		socket().on('alert.resolved', (data) => {
			this.newAlertResolved(data);
		});
	}

	componentDidMount() {
		this.loadForm();

		socket().emit('alert.join');
	}

	componentWillUnmount() {
		socket().emit('alert.leave');
	}

	loadForm = async () => {
		const {notifyError} = this.props;
		try {
			const response = await api.get('/alert/view-station-manager');

			const stations = response.data.stations;

			let stationsList = [];
			let stationAlertsList = [];
			let searchForm = {
				station_id: '',
				station_alert_id: ''
			};
			if(stations.length) {
				stationsList = stations.map(item => ({
					value: item.id,
					label: item.name
				}));
				stationAlertsList = stations[0].station_alerts.map(item => ({
					value: item.id,
					label: item.name
				}));

				//searchForm.station_id = stations[0].id;
			}

			this.setState({
			    isLoading: false,
				stations: stations,
				stationsList: stationsList,
				stationAlertsList: stationAlertsList,
				searchForm: searchForm
            });

			this.handleSearchFormSubmit(searchForm);
		} catch (error) {
			notifyError(error.message);
		}
	};

	updateSearchForm = (object) => {
		const searchForm = {
			...this.state.searchForm,
			...object
		};
		this.setState({
			searchForm: searchForm
		});

		this.handleSearchFormSubmit(searchForm);
	};

	searchFormSubmit = (e) => {
		e.preventDefault();
		return this.handleSearchFormSubmit();
	};

	handleSearchFormSubmit = async (values) => {
		const {notifyError} = this.props;
		this.setState({isLoading: true});
		try {
			const formData = Object.assign({}, values);
			const response = await api.post('/alert/view-station-manager', formData);
			//notifySuccess(response.message);

			const alerts = response.data.alerts.map(item => ({
				id: item.id,
				stationName: item.station.name,
				name: item.name,
				icon: item.icon,
				iconUrl: item.icon_url,
				status: item.status,
				formattedCreatedAt: formatDate(item.created_at, 'MMM DD, YYYY HH:mm:ss'),
				openDuration: moment.duration(moment().diff(moment(item.created_at))).humanize()
			}));

			this.setState({isLoading: false, alerts: alerts});
		} catch (error) {
			this.setState({isLoading: false});
			notifyError(error.message);
		}
	};

	stationSelected = (stationId) => {
		this.updateSearchForm({station_id: stationId || ''})
	};

	stationAlertSelected = (stationAlertId) => {
		this.updateSearchForm({station_alert_id: stationAlertId || ''})
	};

	resolveButtonClicked = async (alertId, e) => {
		const {notifySuccess, notifyError} = this.props;
		// const {searchForm} = this.state;
		try {
			const values = { id: alertId };
			const response = await api.post('/alert/resolve', values);
			notifySuccess(response.message);

			//this.handleSearchFormSubmit(searchForm);

		} catch (error) {
			notifyError(error.message);
		}
	};

	newAlertCreated = (data) => {
		const {stations, alerts} = this.state;

		const stationId = data.station_id;
		const canAccessStation = stations.find((item) => item.id === stationId);

		if(canAccessStation) {
			const alert = {
				id: data.id,
				stationName: data.station.name,
				name: data.name,
				icon: data.icon,
				iconUrl: data.icon_url,
				status: data.status,
				formattedCreatedAt: formatDate(data.created_at, 'MMM DD, YYYY HH:mm:ss'),
				openDuration: moment.duration(moment().diff(moment(data.created_at))).humanize()
			};

			this.setState({
				alerts: [alert, ...alerts]
			});

			this.toggleAnimation(data.flash_color);
		}
	};

	newAlertResolved = (data) => {
		const {stations, alerts} = this.state;
		const stationId = data.station_id;
		const canAccessStation = stations.find((item) => item.id === stationId);

		if(canAccessStation) {
			const newAlerts = alerts.filter((item) => item.id !== data.id);
			this.setState({
				alerts: [...newAlerts]
			});
		}
	};

	toggleAnimation = (color) => {
		this.setState({
			showAnimation: color
		});
		setTimeout(() => {
			this.setState({
				showAnimation: ''
			});
		}, 5000)
	};

	render() {
		const {translate} = this.props;
		const {isLoading, stationsList, stationAlertsList, alerts, searchForm, showAnimation } = this.state;

		const content = (
			<div className={`content-wrapper ${showAnimation === 'High' && 'highlight-red'} ${showAnimation === 'Medium' && 'highlight-orange'}`}>
				<div className="container">
					<section className="content">
						<div className="box">
							<div className="box-body with-padding">
								<form onSubmit={this.formSubmit}>
									<div className="row">
										<div className="col-sm-3">
											<div className="form-group">
												<Label text="Station" />
												<Select list={stationsList} clearable={true} value={searchForm.station_id}  onChange={selected => this.stationSelected(selected)} />
											</div>
										</div>
										<div className="col-sm-3">
											<div className="form-group">
												<Label text="Alerts" />
												<Select list={stationAlertsList} clearable={true} value={searchForm.station_alert_id} onChange={selected => this.stationAlertSelected(selected)} />
											</div>
										</div>
										<div className="col-md-2">
											<div className="form-group">
												{
													(searchForm.station_alert_id) && (
														<div/>
													)
												}
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>

						{
							alerts.map((alert, index) => (
								<div className="info-box info-box-icon-right" key={`alert_page_box_${index}`}>
									{
										(alert.status === 'Created') && (
											<span className="info-box-icon" style={{backgroundColor: 'white'}}>
												<button className="btn btn-success btn-inverse" onClick={e => this.resolveButtonClicked(alert.id, e)}>
													<i className="fa fa-check"/>
												</button>
											</span>
										)
									}
									<div className="info-box-content" style={{paddingBottom: "0"}}>
										<div className="row">
											<div className="col-md-2">
												<span className="info-box-text">Station</span>
												<span className="info-box-number">{alert.stationName}</span>
											</div>
											<div className="col-md-3">
												<span className="info-box-text">Name</span>
												<span className="info-box-number">{alert.name}</span>
											</div>
											<div className="col-md-2">
												<img height="80px" src={alert.iconUrl} alt=""/>
											</div>
											<div className="col-md-2">
												<span className="info-box-text">Created At</span>
												<span className="info-box-number">{alert.formattedCreatedAt}</span>
											</div>
											<div className="col-md-2">
												<span className="info-box-text">Open Duration</span>
												<span className="info-box-number">{alert.openDuration}</span>
											</div>
										</div>
									</div>
								</div>
							))
						}
					</section>
				</div>
			</div>
		);
		return translate('station_manager_alert_dashboard_page_title') && !isLoading ? content : <ContentLoader/>;
	}
}

const mapStateToProps = state => ({
	translate: getTranslate(state.locale)
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifySuccess,
	notifyError,
	notifyShow
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StationManagerAlertDashboard);
